import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    // Vérifier si le lien est actif
    const isActive = (path) => {
        return location.pathname.startsWith(path);
    };

    // Fonction pour basculer le menu mobile
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    // Détecter le changement de taille d'écran pour fermer le menu si on passe en desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768 && mobileMenuOpen) {
                setMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [mobileMenuOpen]);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-logo">
                    <Link to="/">
                        <img src="/logo_dark.webp" alt="Astra Logo" />
                    </Link>
                </div>
                
                {/* Hamburger menu pour mobile */}
                <div className="hamburger-menu" onClick={toggleMobileMenu}>
                    <div className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                
                {/* Navbar links */}
                <div className={`navbar-links ${mobileMenuOpen ? 'mobile-active' : ''}`}>
                    <Link 
                        to="/calcul-theme-astral" 
                        className={`navbar-link ${isActive('/calcul-theme-astral') ? 'active' : ''}`}
                        aria-label="Thème Astral"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        Thème Astral
                    </Link>
                    <Link 
                        to="/compatibilite-amoureuse-astrologie" 
                        className={`navbar-link ${isActive('/compatibilite-amoureuse-astrologie') ? 'active' : ''}`}
                        aria-label="Compatibilité Astrologique"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        Compatibilité
                    </Link>
                    <Link 
                        to="/horoscope-hebdomadaire" 
                        className={`navbar-link ${isActive('/horoscope-hebdomadaire') ? 'active' : ''}`}
                        aria-label="Horoscope"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        Horoscope
                    </Link>
                    <Link 
                        to="/blog" 
                        className={`navbar-link ${isActive('/blog') ? 'active' : ''}`}
                        aria-label="Blog Astrologique"
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        Blog
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar; 